
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Selector from 'vux/src/components/selector/index.vue'

import Vue from "vue";

export default {
components: {
XHeader,
XButton,
Group,
Cell,
XSwitch,
Selector
},
data() {
return {
queryType: this.$route.query.type,
showModelType: this.GLOBAL.SubjectShowModelType.Setting,
fontList: [
{ key: "0", value: "小号" },
{ key: "1", value: "中号" },
{ key: "2", value: "大号" },
{ key: "3", value: "特大" },
{ key: "4", value: "超大" }
], //字体选项
settingFont: "1", //字体大小
nightMode: false, //夜晚模式
greenMode:false,
moveNextType:false,
showAnswerAfterDo:true,
clearTestHistory: false, //清空练习记录
clearCollect: false, //清空我的收藏
clearSimulationPaper: false 
};
},
created() {
if(this.queryType == 1) {
this.showModelType = this.GLOBAL.SubjectShowModelType.Clear;
}
var myset = this.$store.getters.getSettingInfo;
if (myset != undefined) {
this.settingFont = myset.FontSize;
this.nightMode = myset.NightMode == "1";
if(myset.GreenMode) this.greenMode = (myset.GreenMode == "1");
if(myset.MoveNextType) this.moveNextType = (myset.MoveNextType == "1");
if(myset.ShowAnswerAfterDo) this.showAnswerAfterDo = (myset.ShowAnswerAfterDo == "1");

}
},
methods: {
changeModelType(type) {

this.showModelType = type;

if (this.showModelType == this.GLOBAL.SubjectShowModelType.Clear) {
this.clearTestHistory = false;
this.clearCollect = false;
this.clearSimulationPaper = false;
}
},
nightModeChange(e){
console.log(e);
},
greenModeChange(e){
console.log(e);
},
onClearBack() {
if(this.queryType == 1) {
this.$router.go(-1);
} else {
this.changeModelType(this.GLOBAL.SubjectShowModelType.Setting)
}
},
setting() {

this.$http({
method: "post",
url: "wxexam.ashx?op=UpdateExamSettings",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
fontsize: this.settingFont,
longbright: 0,
nightmode: this.nightMode ? 1 : 0,
greenMode: this.greenMode ? 1 : 0,
moveNextType: this.moveNextType ? 1 : 0,
showAnswerAfterDo: this.showAnswerAfterDo ? 1 : 0
}
})
.then(response => {
if (response.status == 200) {
if (response.data.errcode == 0) {
var settings = response.data;
var localSettingInfo = {
FontSize: this.settingFont,
LongBright: 0,
NightMode: this.nightMode ? 1 : 0,
GreenMode: this.greenMode ? 1 : 0,
MoveNextType: this.moveNextType ? 1 : 0,
ShowAnswerAfterDo: this.showAnswerAfterDo ? 1 : 0
};
this.$store.commit("$_setSettingInfo", localSettingInfo);

this.$vux.toast.text("保存设置成功", "bottom");
this.$router.go(-1);
}
}
})
.catch(function(error) {
console.log("error:" + error);
});
},
clearCourse() {

const _this = this;
this.$vux.confirm.show({
title: "清空题库",
content: "确定要清空本课程的资料吗？",
onConfirm() {
_this
.$http({
method: "post",
url: "wxexam.ashx?op=ClearCourse",
params: {
cusId: _this.$store.getters.getUserInfo.CusId,
courseId: _this.$store.getters.getClassInfo.CourseId,
clearTestHistory: _this.clearTestHistory,
clearCollect: _this.clearCollect,
clearSimulationPaper: _this.clearSimulationPaper
}
})
.then(response => {
if (response.status == 200) {
if (response.data.errcode == 0) {
_this.$vux.toast.text("清空题库成功", "bottom");
_this.changeModelType(this.GLOBAL.SubjectShowModelType.Setting);
}
}
})
.catch(function(error) {
console.log("error:" + error);
});
}
});
}
}
};



// WEBPACK FOOTER //
// ./src/components/Setting.vue